/* eslint-disable */
(function() {
  var $ = require('jquery');

  var $nav = $('nav');
  var $primaryNavHolder = $('.js-primary-header');
  var $subNavHolder = $('.js-sub-nav-holder');
  var $subNav = $('.js-sub-nav');
  var $subNavButton = $('.js-show-sub-nav');
  var ACTIVE = 'is-active';
  const PADDING = 'primary-header--padded';
  const FIXED = 'sub-nav--fixed';

  if ($subNavHolder.length && matchMedia('(max-width: 767px)').matches === false) {
    const initialSubNavPos = $subNavHolder.offset().top;

    $(window).on('scroll', function() {
      const windowPos = $(window).scrollTop();

      if (windowPos > initialSubNavPos) {
        $primaryNavHolder.addClass(PADDING);
        $subNavHolder.addClass(FIXED);
      } else if (windowPos < initialSubNavPos) {
        $primaryNavHolder.removeClass(PADDING);
        $subNavHolder.removeClass(FIXED);
      }
    });
  }

  $nav.find('ul li a').click(function(e) {
    var $this = $(this).parent('li');

    if ($this.hasClass('drop-open')) {
      closeNavBlock($this);
      return false;
    } else {
      if ($this.children('.drop').length) {
        closeBeforeOpenNavBlock($this);
        showNavBlock($this);

        return false;
      }
    }
  });

  // show menu block
  function showNavBlock($this) {
    if ($('nav ul li').hasClass('drop-open')) {
      if ($this.hasClass('drop-open')) {
        return true;
      } else {
        closeBeforeOpenNavBlock($this);
        return false;
      }
    } else {
      openNavBlock($this);
      return false;
    }
  }

  // open nav block with animation depending on window width
  function openNavBlock($this) {
    var $ulList = $('nav > ul');
    var $listHeight = $('nav > ul').outerHeight();
    var $dropHeight = 0;
    var $headerHeight = $('header').outerHeight();

    //With opacity still on 0, it shows the drop, gets the height and hides it again.
    //then sets opacity back to 1
    $this.find('.drop').show();
    $dropHeight = $this.find('.drop').outerHeight();
    $this.find('.drop').css({
      display: 'none',
      opacity: '1',
    });
    //with the height already in a variable you can now show the dropdown as normal

    //animates content back to be the dropdown and header height, also slides down the selected dropdown
    resizeContent($this, $dropHeight, $headerHeight);
    $this.addClass('drop-open');

    if ($(window).innerWidth() > 767 && $(window).innerWidth() < 992) {
      $this
        .find('.drop')
        .stop()
        .fadeIn();
      if ($dropHeight > $listHeight) {
        $ulList.animate(
          {
            height: $dropHeight,
          },
          400,
        );
      } else {
        $ulList.animate(
          {
            height: '100%',
          },
          400,
        );
      }
    } else {
      $this
        .find('.drop')
        .stop()
        .slideDown();
    }
  }

  // close old nav, then open selected nav block with animation depending on window width
  function closeBeforeOpenNavBlock($this) {
    if ($(window).innerWidth() > 991 || $(window).innerWidth() < 768) {
      $('.drop-open')
        .find('.drop')
        .stop()
        .slideUp(400, function() {
          $('.drop-open').removeClass('drop-open');
          $('.drop').css('opacity', '0');
          openNavBlock($this);
        });
    } else {
      $('.drop-open')
        .find('.drop')
        .stop()
        .fadeOut(400, function() {
          $('.drop-open').removeClass('drop-open');
          $('.drop').css('opacity', '0');
          openNavBlock($this);
        });
    }
  }

  // close nav
  function closeNavBlock($this) {
    // var $contentwrap = $('.content-wrap');
    // var $headerHeight = $('header').outerHeight();

    $('.drop-open')
      .find('.drop')
      .stop()
      .slideUp(400, function() {
        //if banner exists
        // if ($('.banner-area').length) {
        //   $contentwrap.animate({
        //     'margin-top': 0
        //   }, 600);
        // }
        // else {
        //   $contentwrap.animate({
        //     'margin-top': $headerHeight + 20
        //   });
        // }

        $('.drop-open').removeClass('drop-open');
        $('.drop').css('opacity', '0');
      });
  }

  // move banner
  function resizeContent($this, dropHeight, headerHeight) {
    // var $contentwrap = $('.content-wrap');

    if (dropHeight === 0 || headerHeight === 0) {
      headerHeight = $('header').outerHeight();

      if ($this === 0) {
        $this = $('nav ul li.drop-open');

        dropHeight = $this.find('.drop').outerHeight();
      }
    }

    //animates content back to be the dropdown and header height, also slides down the selected dropdown
    // if (dropHeight > 0 && headerHeight > 0) {
    //   $contentwrap.animate({
    //     'margin-top': dropHeight + headerHeight
    //   }, 400);
    // }
  }

  //menu click animates button

  $('.menu-btn').click(function() {
    if (!$(this).hasClass('menu-open')) {
      if ($(window).innerWidth() > 767 && $(window).innerWidth() < 992) {
        //adds open class and slides down content
        //shows first dropdown
        $(this).addClass('menu-open');
        $('.desktop-nav')
          .stop()
          .slideDown(600);
        var $firstItem = $nav.find('ul li:nth-child(2)');
        showNavBlock($firstItem);
      } else if ($(window).innerWidth() < 768) {
        //adds class to inner wrapper and slides out, animated in css
        $(this).addClass('menu-open');
        $('.inner-wrapper').addClass('move-wrapper');
        $('.moved-nav').addClass('slide-open');
      }
    } else {
      if ($(window).innerWidth() > 767 && $(window).innerWidth() < 992) {
        //adds open class and slides up content
        $(this).removeClass('menu-open');
        $('.desktop-nav')
          .stop()
          .slideUp(600);
      } else if ($(window).innerWidth() < 768) {
        //removes class on inner wrapper and slides in, animated in css
        $(this).removeClass('menu-open');
        $('.inner-wrapper').removeClass('move-wrapper');
        $('.moved-nav').removeClass('slide-open');
      }
    }
  });

  //menu click resize
  function menuResize() {
    if ($(window).innerWidth() > 767) {
      $('.menu-btn').removeClass('menu-open');
      $('.inner-wrapper').removeClass('move-wrapper');
      $('.moved-nav').removeClass('slide-open');
      $('.desktop-nav nav .page-links').appendTo('.left-links');
    } else {
      $('.left-links ul').appendTo('.desktop-nav nav');
    }
  }
  menuResize();

  //click body to close nav dropdown
  $(document).mouseup(function(e) {
    var dropDown = $('.drop-open');
    // var $contentwrap = $('.content-wrap');
    // var $headerHeight = $('header').outerHeight();

    // if the target of the click isn't the container nor a descendant of the container
    if (!dropDown.is(e.target) && dropDown.has(e.target).length === 0) {
      $('.drop-open')
        .find('.drop')
        .stop()
        .slideUp(400, function() {
          //if banner exists
          // if ($('.banner-area').length) {
          //   $contentwrap.animate({
          //     'margin-top': 0
          //   }, 600);
          // }
          // else {
          //   $contentwrap.animate({
          //     'margin-top': $headerHeight + 20
          //   });
          // }

          $('.drop-open').removeClass('drop-open');
          $('.drop').css('opacity', '0');
        });
    }
  });

  function ipadNavDimentions() {
    //gets the width of the current window
    //works out the width remaining from the parents width
    //sets new width for the nav item
    var $windowWidth = $(window).outerWidth();
    var $listWidth = $('.desktop-nav').outerWidth();
    var $newItemWidth = $windowWidth - $listWidth - 20;

    $('nav ul li')
      .find('.drop')
      .css('width', $newItemWidth);

    $('nav > ul').outerHeight();
    $('nav ul')
      .find('.drop')
      .outerHeight();
  }

  if ($subNavButton.length) {
    $subNavButton.on('click', function() {
      $subNavButton.toggleClass(ACTIVE);
      $subNav.toggleClass(ACTIVE);
    });
  }

  if ($(window).innerWidth() < 992) {
    ipadNavDimentions();

    //moves the nav to correct position for iPad
    $('.back-to-desktop .desktop-nav').appendTo('.moved-nav');
  } else {
    //moves the nav back to correct position for desktop
    $('.moved-nav .desktop-nav').appendTo('.back-to-desktop');
  }

  $(window).resize(function() {
    //resize viewport function
    function viewport() {
      var e = window,
        a = 'inner';
      if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
      }
      return {
        width: e[a + 'Width'],
        height: e[a + 'Height'],
      };
    }

    menuResize();

    if (viewport().width >= 991) {
      $('.moved-nav .desktop-nav').appendTo('.back-to-desktop');
      $('.back-to-desktop .desktop-nav').show();
      $('nav ul').removeAttr('style');
      $('nav ul li')
        .find('.drop')
        .css('width', '100%');

      setTimeout(function() {
        resizeContent(0, 0, 0);
      }, 500);
    } else {
      $('.back-to-desktop .desktop-nav').appendTo('.moved-nav');
      ipadNavDimentions();
    }
  });
})();
